import React from "react";
import ReactDOM from "react-dom";
import { PropTypes } from "prop-types";
import { SocialShare, WithHostUrl, Link } from "@quintype/components";
import { get } from "lodash";
import { connect } from "react-redux";
import StoryHeader from "./story-templates/shared/story-header";
import TextStoryHeader from "./story-templates/shared/text-story-header";
import StoryPremiumCard from "../../atoms/story-premium-card";
import { STORY_TEMPLATES } from "../../../constants";
import { TextStory } from "./story-templates/text-story-page";
import { PhotoAlbumStory } from "./story-templates/photo-album-story";
import { VideoStory } from "./story-templates/video";
import { PhotoStory } from "./story-templates/photo";
import { ListicleStory } from "./story-templates/listicle-story";
import { LongFormStory } from "./story-templates/long-form";
import { ReviewStory } from "./story-templates/review";
import { LiveBlogStory } from "./story-templates/live-blog";
import { Explainer } from "./story-templates/explainer";
import { SocialShareTemplate } from "./story-templates/shared/social-share";
import { CartoonStory } from "./story-templates/cartoon";
import Tags from "./story-templates/shared/tags";
import { getParentSection } from "../../../data/section";
import AuthorDetail from "./story-templates/shared/author-detail";
import { DfpAd } from "../../atoms/dfp-ad";
import {
  fetchStoryAttributes,
  fetchLatestAtVikatan,
  fetchTrendingStories,
  fetchEvRecommendation,
  fetchLatestVideos,
  fetchOneTabLogin,
  fetchvuuklegetCommentCount
} from "../../../api";
import { GA, WebEngage, DeepBI, currentStory, LoadVuukle, EVOLOK, PGAD, STORY_TRACKING } from "../../../integrations";
import { isPremium } from "../../../data/story";
import SecondaryMenu from "../../atoms/secondary-menu";
import Cookies from "universal-cookie";
import styles from "./styles.m.css";
import { checkMagazineUTM, isGaa, removeBulletImagesFromStory } from "../../utils/utils";
import StorySecondaryCard from "./story-templates/shared/story-secondary-card";
import Media from "react-media";
import RelatedStoryWidget from "../../../components/pages/story/story-templates/shared/related-story-widget";
import LatestStoryWidget from "../../../components/pages/story/story-templates/shared/Latest-story-widget";
import Vuukle from "./story-templates/shared/vuukle";
import { VikatanEndArticle, VikatanBetweenArticle, PGAdwithAd, VikatanSticky } from "../../rows/ad-free";
import { TaboolaAd } from "../../atoms/taboola-ad";
import SpecialBundleCard from "../../atoms/special-bundle-card";
import EvolokRecommendationUnit from "../../rows/evolok-recommendation";
import SmallStoryCardCurve from "../../atoms/small-story-card-with-curve";
import { MagazineStory } from "./story-templates/magazine-story-page";
import Icon from "../../atoms/icon";

const cookies = new Cookies();

function getStoryTemplateComponent(storyTemplate) {
  switch (storyTemplate) {
    case STORY_TEMPLATES.VIDEO:
      return VideoStory;
    case STORY_TEMPLATES.PHOTO:
      return PhotoStory;
    case STORY_TEMPLATES.PHOTO_ALBUM:
      return PhotoAlbumStory;
    case STORY_TEMPLATES.REVIEW:
      return ReviewStory;
    case STORY_TEMPLATES.LISTICLE:
      return ListicleStory;
    case STORY_TEMPLATES.LIVE_BLOG:
      return LiveBlogStory;
    case STORY_TEMPLATES.LONG_FORM:
      return LongFormStory;
    case STORY_TEMPLATES.EXPLAINER:
      return Explainer;
    case STORY_TEMPLATES.CARTOON:
      return CartoonStory;
    default:
      return TextStory;
  }
}

function appendCustomQueryStringUrl(story, view = "normal") {
  let newObj = {};
  newObj = story;
  newObj.pfrom = view;
  return newObj;
}

const magazineGridList = (issueCollection, setClassName, storyId) => {
  const storyMap = issueCollection && getStoriesByLabel(issueCollection);

  const rootMenuGroup =
    issueCollection &&
    Object.keys(storyMap).map((label, idx) => {
      return {
        title: label,
        id: idx,
        items: storyMap[label].map(storyObject => {
          return storyObject;
        })
      };
    });

  const menuTitle =
    issueCollection &&
    rootMenuGroup.map((item, id) => {
      return (
        <div key={id}>
          <div className={styles["card-title"]}>{item.title}</div>
          <div className={`${styles[setClassName]}`}>
            {item.items.map((story, ids) => (
              <div key={ids} className={`${styles["magazine-card"]} ${story.id === storyId && styles["active"]}`}>
                <SmallStoryCardCurve story={story} />
              </div>
            ))}
          </div>
        </div>
      );
    });

  return menuTitle;
};

const episodeGridList = (episodes, storyId) => {
  const episodeList =
    episodes &&
    episodes
      .map((story, id) => {
        if (storyId !== story.id) {
          return (
            <div key={id} className={`${styles["magazine-card"]}`}>
              <SmallStoryCardCurve story={story} />
            </div>
          );
        }
      })
      .filter(i => i);

  return episodeList;
};

class StoryTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedStories: [],
      visualStories: null,
      trendingStories: [],
      access: null,
      socialView: false,
      width: global.innerWidth,
      showModal: !!cookies.get("userPaid"),
      activePaywall: this.props.activePaywall,
      activeStdPaywall: this.props.activeStdPaywall,
      jshow: false,
      userType: "F",
      show_rfm: false,
      evAccess: "ALLOW_ACCESS",
      evAudioAccess: "PREMIUM_ACCESS",
      evSegments: [],
      latestVideos: null,
      HideFooterElements: true,
      commentsCount: {}
    };
    this.floatingbar = React.createRef();
    this.handleClickView = this.handleClickView.bind(this);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    const { index } = this.props;

    const storyId = get(this.props, ["story", "id"], null);

    global.userPromise.catch(() => null).then(user => {
      user && this.setState({ userType: user.userType });
    });

    if (index === 0 && isPremium(this.props.story)) {
      currentStory.storyCookie(this.props.story, "");
    }

    if (index === 0) {
      this.setState({
        show_rfm: !this.state.show_rfm
      });
      const fetchInitializerListenerId = setInterval(() => {
        if (cookies.get("ev_sid")) {
          this.handleEvFetch();
          clearInterval(fetchInitializerListenerId);
        }
        //
      });
      const magazineEntity = get(this.props, ["magazineEntity"], null);

      EVOLOK.loadScript(
        "story-page",
        {
          story: this.props.story,
          collection: { ...this.props.issueCollection, magazineEntity: magazineEntity }
        },
        this.handleMeteringSuccess
      );
    } else {
      this.handleEvFetch();
    }
    if (global && global.matchMedia("(min-width: 768px)").matches && this.props.story["story-template"] === "video") {
      fetchLatestVideos(0, 5, { "exclude-story-ids": storyId })
        .then(response => {
          this.setState({ latestVideos: response && response });
        })
        .catch(console.error);
    }
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        this.setState({ commentsCount: res.data });
      })
      .catch(console.error);
  }

  handleMeteringSuccess = response => {
    const { story, issueCollection } = this.props;
    const storyTemplate = get(story, ["story-template"], "");
    if (response.result !== "ALLOW_ACCESS") {
      if (storyTemplate !== "app-stories") {
        DeepBI.paywallStory(story, issueCollection, "premium", "", "std");
      }
    }
    if (!isGaa()) {
      this.setState({
        evAccess: response.result,
        evSegments: response.segments,
        evAudioAccess: response.result
      });
    }
  };

  handleEvFetch = () => {
    fetchEvRecommendation(cookies.get("ev_sid"))
      .then(data => {
        const evData = get(data, ["recommendations"], []);
        this.setState({ evList: evData });
      })
      .catch(console.error);
  };

  componentWillReceiveProps(nextState) {
    if (this.state.activeStdPaywall !== nextState.activeStdPaywall) {
      this.setState({ activeStdPaywall: false });
    }
  }

  handleExpandStory = () => {
    this.setState({
      show_rfm: !this.state.show_rfm
    });
    this.props.firePageView(this.props.story, true);
    global.app.maybeSetUrl(
      "/" + this.props.story.slug + "?pfrom=latest-infinite",
      get(this.props, ["story", "seo", "meta-title"], this.props.story.headline)
    );
    this.props.checkInfoStatus({ id: this.props.story.id, status: true });

    const magazineEntity = get(this.props, ["magazineEntity"], null);
    EVOLOK.loadScript(
      "story-page",
      {
        story: this.props.story,
        collection: { ...this.props.issueCollection, magazineEntity: magazineEntity }
      },
      this.handleMeteringSuccess
    );
  };

  handleClickView() {
    window.scrollTo({
      top: this.floatingbar.current.offsetTop - 120,
      behavior: "smooth"
    });
  }

  handleClickEvents(args) {
    GA.customEvent(args, this.props.story.id);
    DeepBI.customEvent(args, this.props.story.id);
  }

  CloseStdPaywall(args) {
    this.props.actionhandleStdActivePaywall(false);
  }

  handleCloseDatawall() {
    this.setState({
      show_rfm: !this.state.show_rfm
    });
  }

  handleScrollComment = () => {
    this.setState({
      HideFooterElements: false
    });
    this.myRef.current.scrollIntoView({ behavior: "smooth", top: "-120px" });
  };

  render() {
    const storyTemplate = get(this.props, ["story", "story-template"]);
    const story = removeBulletImagesFromStory(get(this.props, ["story"], null));
    if (!story) {
      return null;
    }
    const config = get(this.props, ["config"]);
    const episodes = get(this.props, ["episodes"]);
    const versionStat = get(story, ["pfrom"], null);
    const singleCard = get(story, ["cards"], []);

    const singleelementWithcard = singleCard
      .map((item, i) => {
        let params = { ...item };
        params["story-elements"] = [item["story-elements"][0]];
        if (i === 0) {
          return params;
        }
      })
      .filter(i => i);

    const renderSocialMedia = (className = "") => (
      <SocialShare
        className={className}
        template={SocialShareTemplate}
        fullUrl={story.url}
        title={story.headline}
        handleClickView={this.handleClickView}
        hashtags={
          story.tags &&
          story.tags
            .filter(tag => tag !== null)
            .map(tag => tag.name)
            .toString()
        }
        story={story}
      />
    );

    const renderHeaderCard = ({ className, readMore } = { className: "", readMore: true }) => (
      <StoryHeader
        // renderSocialMedia={renderSocialMedia}
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
        readMore={readMore}
      />
    );

    const renderTextStoryHeaderCard = ({ className, readMore } = { className: "", readMore: true }) => (
      <TextStoryHeader
        // renderSocialMedia={renderSocialMedia}
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
        readMore={readMore}
      />
    );

    const renderSecondaryCard = ({ className } = { className: "" }) => (
      <StorySecondaryCard
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
      />
    );

    const renderTags = () => <Tags tags={story.tags} className={styles.tags} />;

    const renderAuthorDetails = () => (
      <AuthorDetail
        authors={story.authors}
        config={config}
        contributors={story.contributors}
        className={styles["author-detail"]}
      />
    );

    const renderRelatedStories = () => (
      <div>
        {this.state.evList ? (
          <EvolokRecommendationUnit
            title="விகடன் பரிந்துரைக்கும் மற்ற கட்டுரைகள்..."
            className={"footer"}
            recommendation={this.state.evList}
            count={4}
            pfrom="ev-recommendation-footer"
          />
        ) : (
          ""
        )}
      </div>
    );

    const renderRelatedArticle = props => {
      const trendingStories = get(this.props, ["trendingStories"]);
      return (
        <React.Fragment>
          <RelatedStoryWidget
            className={`${styles["related-stories"]} js-related-stories`}
            collection={{
              name: "இந்தக் கட்டுரைகளையும் படிக்கலாமே!",
              trending:
                trendingStories &&
                trendingStories.length > 0 &&
                trendingStories.slice(0, 10).map(data => {
                  let item = data.story;
                  return { item };
                })
            }}
          />
        </React.Fragment>
      );
    };

    const leftSidebarRestrict = () => {
      const issueCollection = get(this.props, ["issueCollection"]);
      const episodes = get(this.props, ["episodes"], null);

      if (!checkMagazineUTM() && episodes) {
        return (
          <React.Fragment>
            <div className={styles["card-title"]}>மற்ற எபிசோடுகள்</div>
            <div className={styles["magazine-card-grid-wrapper"]}>
              {episodeGridList(this.props.episodes, this.props.story.id)}
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            {magazineGridList(issueCollection, "magazine-card-grid-wrapper", this.props.story.id)}
          </React.Fragment>
        );
      }
    };

    const renderSidebar = (adshow = true) => {
      const issueCollection = get(this.props, ["issueCollection"]);
      const episodes = get(this.props, ["episodes"], null);
      const magazineView = get(issueCollection, ["magazineView"]);
      return (episodes || issueCollection) && magazineView ? (
        <div className={styles["lefts-side-menu"]}>{leftSidebarRestrict()}</div>
      ) : (
        <aside className={styles.sidebar}>
          <Media query="(min-width:768px)">
            <PGAdwithAd unit="Vikatan_article_mrec_top" class="ad_300_250" />
          </Media>

          <Media query="(min-width:768px)">
            <div className="hidden-mobile">
              {storyTemplate === "video"
                ? this.state.latestVideos && (
                    <LatestStoryWidget
                      className={`${styles["related-stories"]} js-related-stories`}
                      collection={this.state.latestVideos}
                      type="videos"
                    />
                  )
                : this.props.latestStories && (
                    <LatestStoryWidget
                      className={`${styles["related-stories"]} js-related-stories`}
                      collection={this.props.latestStories}
                      type="normal"
                    />
                  )}
            </div>
          </Media>

          {adshow && (
            <Media query="(min-width:768px)">
              <PGAdwithAd unit="Vikatan_article_mrec_mid" class="ad_300_250" />
            </Media>
          )}

          <Media query="(min-width:768px)">
            <div className="hidden-mobile">
              {this.state.evList ? (
                <EvolokRecommendationUnit
                  className={"sidebar"}
                  title="பரிந்துரைக்கும் கட்டுரைகள்"
                  recommendation={this.state.evList}
                  count={5}
                  pfrom="ev-recommendation-sidebar"
                />
              ) : (
                ""
              )}
            </div>
          </Media>

          {adshow && (
            <Media query="(min-width:768px)">
              <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
                {this.state.userType === "P" || this.state.userType === "T" || this.state.userType === "R" ? (
                  <SpecialBundleCard className="feed-page" />
                ) : (
                  <PGAdwithAd unit="Vikatan_article_sidebar_sticky" class="ad-300x600" />
                )}
              </div>
            </Media>
          )}
        </aside>
      );
    };

    const renderFooter = (isOpen = false, cardScroll) => {
      return (
        <div className="js-story-footer">
          {!isOpen && !isGaa() ? <ev-engagement /> : ""}
          {!isPremium(this.props.story) && !isOpen && renderRelatedArticle()}

          {!isOpen && (
            <div onClick={this.handleScrollComment} className={styles["commen-list-botton"]}>
              <div className={styles["comment-btn"]}>
                {this.state.commentsCount[this.props.story.id] === 0
                  ? "Post a Comment"
                  : this.props.story.id && this.state.commentsCount[this.props.story.id] !== undefined
                    ? `View Comments (${this.state.commentsCount[this.props.story.id]})`
                    : "View Comments"}
              </div>
            </div>
          )}
          {!isOpen &&
            !this.state.HideFooterElements && (
              <div className={styles["Vuukle-comments"]}>
                <strong>
                  இதில் பின்னூட்டம் இடுபவர்களின் கருத்துகள் அவரவர் தனிப்பட்ட கருத்து, விகடன் இதற்கு பொறுப்பேற்காது.
                </strong>
              </div>
            )}

          <div
            ref={this.myRef}
            className={`${!this.state.HideFooterElements ? styles["show-vuukle"] : styles["hide-vuukle"]} test-slot`}
          >
            <Vuukle story={story} vuukleConfig={this.props.config.vikatanHosts} />
          </div>
          {!isOpen && renderTags()}
          {!isOpen && <VikatanEndArticle placement="story" className="end-article" />}

          {!isPremium(this.props.story) && !isOpen ? renderRelatedStories() : ""}
          <div className="taboola-outer">
            <TaboolaAd
              config={{
                mode: "thumbnails-a",
                id: "taboola-below-article-thumbnails",
                placement: "Below Article Thumbnails"
              }}
              url={global && global.location && global.location.href}
              className={"taboola-article"}
              directory={"article"}
            />
          </div>

          <div className={styles["space-before-next-story"]} />
        </div>
      );
    };

    const renderFooterMagazine = () => {
      const issueCollection = get(this.props, ["issueCollection"]);
      const magazineView = get(issueCollection, ["magazineView"]);
      return magazineView && issueCollection ? (
        <div className={styles["footer-magazine-wrapper"]}>
          <div className={styles["footer-list-mag"]}>{leftSidebarRestrict()}</div>
        </div>
      ) : (
        <div />
      );
    };

    const renderPremiumCard = () => {
      return <React.Fragment>{isPremium(this.props.story) && <StoryPremiumCard />}</React.Fragment>;
    };

    const GetStoryScrollPercentage = percentage => {
      this.props.GetScrollValue(percentage);
    };

    const renderProps = {
      renderSocialMedia,
      renderTags,
      renderAuthorDetails,
      renderHeaderCard,
      renderTextStoryHeaderCard,
      renderSidebar,
      renderFooter,
      renderPremiumCard,
      renderSecondaryCard,
      renderRelatedArticle,
      renderFooterMagazine,
      GetStoryScrollPercentage
    };

    const issueCollectionObj = get(this.props, ["issueCollection"]);
    const magazineView = get(issueCollectionObj, ["magazineView"]);

    const StoryTemplateComponent =
      magazineView && (episodes || issueCollectionObj)
        ? MagazineStory
        : getStoryTemplateComponent(story["story-template"]);
    return (
      <StoryTemplateComponent
        story={{
          ...story,
          cards: this.state.evAccess !== "ALLOW_ACCESS" && !isGaa() ? singleelementWithcard : story.cards
        }}
        config={config}
        episodes={episodes}
        {...renderProps}
        fireVirtualPageView={this.props.firePageView}
        READMORE_ENABLE={this.props.READMORE_ENABLE}
        relatedStories={this.state.relatedStories}
        checkInfoStatus={this.props.checkInfoStatus}
        versionStat={versionStat}
        handleExpandStory={this.handleExpandStory}
        index={this.props.index}
        evAccess={this.state.evAccess}
        evAudioAccess={this.state.evAudioAccess}
      />
    );
  }
}

export class StoryFeedPageBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      story,
      episodes,
      config,
      metypeConfig,
      firePageView,
      issueCollection,
      READMORE_ENABLE,
      index,
      checkInfoStatus,
      versionStat,
      actionhandleActivePaywall,
      activePaywall,
      activeStdPaywall,
      actionhandleStdActivePaywall,
      GetScrollValue,
      latestStories,
      trendingStories,
      paywallPlans,
      razaorpayKey,
      magazineEntity
    } = this.props;

    let readmoreStat = READMORE_ENABLE;

    const sections = [get(story, ["sections", 0], {})];
    const parentSection = getParentSection(sections[0]);
    if (parentSection) {
      sections.unshift(parentSection);
    }
    const subsection = get(sections, [1, "name"]) || "";

    return (
      <div className={`js-content-insights-${story.id}`}>
        <div data-subsection={subsection} className="subsection-event" />
        {index !== 0 && <VikatanBetweenArticle placement="story" />}

        <StoryTemplate
          story={story}
          config={config}
          episodes={episodes}
          metypeConfig={metypeConfig}
          paywallPlans={paywallPlans}
          razaorpayKey={razaorpayKey}
          firePageView={firePageView}
          issueCollection={issueCollection}
          READMORE_ENABLE={readmoreStat}
          checkInfoStatus={checkInfoStatus}
          versionStat={versionStat}
          index={index}
          actionhandleActivePaywall={actionhandleActivePaywall}
          activePaywall={activePaywall}
          actionhandleStdActivePaywall={actionhandleStdActivePaywall}
          GetScrollValue={GetScrollValue}
          activeStdPaywall={activeStdPaywall}
          latestStories={latestStories}
          trendingStories={trendingStories}
          magazineEntity={magazineEntity}
        />
        <div>
          {index % 3 === 0 && index !== 0 ? (
            <div className={`${styles["ad-wrapper"]} margin-top hidden-desktop hidden-tablet`}>
              <DfpAd story={story} adtype="Rectangle" placement="story" className="hidden-desktop hidden-tablet" />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
StoryFeedPageBase.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: TextStory.propTypes.story,
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  recentStory: PropTypes.object,
  paywallPlans: PropTypes.object,
  razaorpayKey: PropTypes.object,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string,
  actionhandleActivePaywall: PropTypes.func,
  activePaywall: PropTypes.bool,
  visualStories: PropTypes.shape(),
  actionhandleStdActivePaywall: PropTypes.func,
  GetScrollValue: PropTypes.func,
  activeStdPaywall: PropTypes.bool,
  latestStories: PropTypes.shape(),
  trendingStories: PropTypes.shape(),
  magazineEntity: PropTypes.shape()
};

StoryTemplate.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: PropTypes.shape(),
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  recentStory: PropTypes.object,
  paywallPlans: PropTypes.object,
  razaorpayKey: PropTypes.object,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string,
  actionhandleActivePaywall: PropTypes.func,
  activePaywall: PropTypes.bool,
  visualStories: PropTypes.shape(),
  actionhandleStdActivePaywall: PropTypes.func,
  GetScrollValue: PropTypes.func,
  activeStdPaywall: PropTypes.bool,
  latestStories: PropTypes.shape(),
  trendingStories: PropTypes.shape(),
  magazineEntity: PropTypes.shape()
};

class WrapperStoryIntersectionObserverBase extends React.Component {
  constructor(props) {
    super(props);
    this.storyRef = React.createRef();
  }

  componentDidMount() {
    this.intersectionObserver =
      global.IntersectionObserver &&
      new global.IntersectionObserver(
        entries => {
          // There will be only One target as we are implementing one Intersection Observer for every Story
          if (entries[0].isIntersecting === true) {
            this.intersectionObserver && this.intersectionObserver.disconnect();
          }
        },
        {
          rootMargin: "0px"
        }
      );
    /* eslint-disable react/no-find-dom-node */
    this.intersectionObserver.observe(ReactDOM.findDOMNode(this.storyRef.current));
  }
  componentWillUnmount() {
    this.intersectionObserver && this.intersectionObserver.disconnect();
  }
  render() {
    return <StoryFeedPageBase {...this.props} ref={this.storyRef} />;
  }
}
// Dispatch the action to update the store from the Intersection Observer
const mapDispatchToProps = dispatch => {
  return {
    updateRemainingStoriesCounter: function(remainingStoriesCount) {
      dispatch({
        type: "UPDATE_STORIES_READ_STATS",
        remainingStoriesCount: remainingStoriesCount
      });
    }
  };
};
const WrapperStoryIntersectionObserver = connect(
  state => state,
  mapDispatchToProps
)(WrapperStoryIntersectionObserverBase);

const getStoriesByLabel = collection => {
  return collection.items.filter(({ story = {} }) => story.headline && story.url).reduce((storyMap, item) => {
    const label = get(item, ["associated-metadata", "label"], "மற்றவை");
    if (storyMap[label]) {
      storyMap[label].push(item.story);
    } else {
      storyMap[label] = [item.story];
    }
    return storyMap;
  }, {});
};

const generateSecondaryMenu = (issueCollection, magazine) => {
  const storyMap = issueCollection && getStoriesByLabel(issueCollection);
  const rootMenuGroup = Object.keys(storyMap).map((label, idx) => {
    return {
      title: label,
      id: idx,
      items: storyMap[label].map(storyObject => {
        return {
          title: storyObject["headline"],
          url: storyObject["url"]
        };
      })
    };
  });

  const firstElement = magazine.name && (
    <Link href={issueCollection.pagePath} className={styles["magazine-name"]}>
      {magazine.name.replace(/\(\w+\)/, "")}
    </Link>
  );
  const root = {
    items: rootMenuGroup
  };
  return (
    <SecondaryMenu
      menuGroup={root}
      className={styles["magazine-secondary"]}
      firstElement={firstElement}
      communityColor={magazine.color}
    />
  );
};

const googleApiClientId = "962641865525-qk3eqej1shfi589ahq1enclp2i5soen0.apps.googleusercontent.com";
const allowedReferrers = ["www.vikatan.com", "vikatan.com", "beta.vikatan.com", "localhost", "localhost:3000"];

export class StoryFeedPage extends React.Component {
  constructor(props) {
    super(props);
    this.firePageView = this.firePageView.bind(this);
    this.cachedFirstPageStories = [];
    this.MAX_ALREADY_STORIES_READ_COUNT = 5;
    this.state = {
      READMORE_ENABLE: false,
      visibleStories: [],
      relatedStories: [],
      latestStories: null,
      trendingStories: null,
      userType: "F",
      activePaywall: true,
      activeStdPaywall: true,
      user: null,
      nextStory: [],
      storyUrls: [],
      isVisible: false,
      evList: [],
      EvAccess: "ALLOW_ACCESS",
      sequnce: 0,
      rndNInt: Math.floor(Math.random() * 11) + 1,
      rndPInt: Math.floor(Math.random() * 11) + 1
    };
    this.checkInfoStatus = this.checkInfoStatus.bind(this);
    this.scrollFunction = this.scrollFunction.bind(this);
    this.UpdateStateScroll = this.UpdateStateScroll.bind(this);
    this.timer = this.timer.bind(this);
  }

  UpdateStateScroll = params => {
    this.setState({
      scroll: params
    });
  };

  timer = args => {
    this.interval = setInterval(() => {
      global.userPromise.catch(() => null).then(user => {
        let userId = get(user, ["userId"], "");
        if (userId === "826969") {
          this.setState({
            sequnce: this.state.sequnce + 1
          });
          STORY_TRACKING.ping(this.state.sequnce, this.state.scroll);
        }
      });
    }, 20000);
  };

  isStoryNotReadYet(storyId) {
    if (!global.localStorage) {
      return true;
    }

    const alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    return !alreadyReadStories.includes(storyId);
  }

  markStoryAsRead(storyId) {
    if (!global.localStorage) {
      return null;
    }

    if (isGaa()) {
      return null;
    }

    let alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    if (alreadyReadStories.length >= this.MAX_ALREADY_STORIES_READ_COUNT) {
      alreadyReadStories = [];
    }
    let alreadyReadStoriesSet = new Set(alreadyReadStories);
    alreadyReadStoriesSet.add(storyId);
    global.localStorage.setItem("alreadyReadStories", JSON.stringify(Array.from(alreadyReadStoriesSet)));
    global.localStorage.removeItem("premiumStoriesRead");
  }

  collectioshema = stories => {
    return stories
      ? stories.map(data => ({
          story: appendCustomQueryStringUrl(data.story),
          id: data.id,
          score: data.score,
          type: data.type,
          item: data.item
        }))
      : [];
  };

  handleLoginPromise = new Promise((resolve, reject) => {
    console.log("login promise");
    global &&
      global.GaaMetering.getLoginPromise().then(() => {
        // Open a login window for existing users to login.
        const curUrl = global && global.location && global.location.href;
        const loginWindow = window.open(`https://login.vikatan.com?redirect_url=${encodeURIComponent(curUrl)}`);

        // Wait for the login window to send a message with userState for the user.
        global.addEventListener(
          "message",
          function(message) {
            if (loginWindow === message.source) {
              resolve(message.data);
            }
          },
          false
        );
      });
  });

  showPaywall() {
    const curUrl = global && global.location && global.location.href;
    console.log("Example: show paywall");
    global.location.href = `https://store.vikatan.com/gns-payment?redirect_url=${encodeURIComponent(curUrl)}`;
  }

  // Callback that must unlock the current article which is called when Google is
  // granting Extended Access to the user.
  // Do not copy the implementation for the callback and see documentation for your own implementation at:
  // https://developers.google.com/news/subscribe/extended-access/integration-steps/web-implementation#handle-extended-access-grants
  unlockArticle() {
    console.log("Example: unlock article");
    document.documentElement.classList.add("open-paywall");
  }

  registerUserPromise = new Promise((resolve, reject) => {
    console.log("register promise");

    global &&
      global.GaaMetering.getGaaUserPromise().then(gaaUser => {
        // gaaUser - registration JWT that is returned by Sign In with Google
        // https://developers.google.com/identity/gsi/web/reference/js-reference?hl=en#credential
        console.log("register promise", gaaUser);
        const gaaUserDecoded = gaaUser.credential;
        fetchOneTabLogin(gaaUserDecoded)
          .then(response => {
            const current = new Date();
            const nextYear = new Date();
            nextYear.setFullYear(current.getFullYear() + 1);
            const resData = get(response, ["data"]);
            const guid = get(response, ["data", "guid"]);
            const evSS = get(response, ["data", "mainSession", "sessionId"]);
            cookies.set("ev-guid", guid, { path: "/", domain: ".vikatan.com", expires: nextYear });
            cookies.set("ev_ss", evSS, { path: "/", domain: ".vikatan.com", expires: nextYear });
            global.localStorage.setItem("evolok:ev_session", JSON.stringify(resData));
            const userState = {
              id: gaaUserDecoded,
              registrationTimestamp: Math.round(Date.now() / 1000),
              granted: false,
              grantReason: "SUBSCRIBER"
            };
            resolve(userState);
          })
          .catch(console.error);
      });
  });

  publisherEntitlementPromise = new Promise(resolve => {
    // Example body of the promise returning a publisherEntitlement object
    const publisherEntitlement = {
      granted: false,
      grantReason: "SUBSCRIBER"
    };
    resolve(publisherEntitlement);
  });

  componentDidMount() {
    window.addEventListener("scroll", this.scrollFunction);
    const current = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(current.getDate() + 28);
    const story = get(this.props, ["data", "story"], {});
    global.localStorage && global.localStorage.setItem("story-view", story.id);
    this.markStoryAsRead(story.id);
    this.firePageView();
    PGAD.loadScript();
    this.timer();
    global.userPromise.catch(() => null).then(user => {
      let userTypeStat = get(user, ["userType"], "F");
      let userId = get(user, ["userId"], null);
      let userJoinDate = get(user, ["userJoinDate"], null);
      const userStatObj = {};
      userStatObj.granted = userTypeStat === "P";
      LoadVuukle.register(story, this.props.config.vikatanHosts);
      if (userId) {
        userStatObj.id = userId;
        userStatObj.registrationTimestamp = userJoinDate;
        userStatObj.grantReason = "SUBSCRIBER";
      }

      this.setState({ userType: userTypeStat, user: user });
      global &&
        global.GaaMetering.init({
          googleApiClientId: googleApiClientId,
          allowedReferrers: allowedReferrers,
          userState: userStatObj,
          unlockArticle: this.unlockArticle,
          showPaywall: this.showPaywall,
          registerUserPromise: this.registerUserPromise,
          handleLoginPromise: this.handleLoginPromise,
          publisherEntitlementPromise: this.publisherEntitlementPromise
        });
    });

    const storyId = get(this.props, ["data", "story", "id"], null);
    if (
      global &&
      global.matchMedia("(min-width: 768px)").matches &&
      this.props.data.story["story-template"] !== "video"
    ) {
      fetchLatestAtVikatan(0, 5, { "exclude-story-ids": storyId })
        .then(response => {
          this.setState({ latestStories: response });
        })
        .catch(console.error);
    }
    fetchTrendingStories(0, 15, { "exclude-story-ids": storyId })
      .then(response => {
        this.setState({ trendingStories: response && response.items });
      })
      .catch(console.error);
  }

  firePageView = (story = this.props.data.story, firedFromInfinite = false) => {
    if (this.props.config.disableAds) {
      return;
    }
    const issueCollection = get(this.props, ["data", "issueCollection"], null);

    currentStory.setStorydata(story, issueCollection);

    fetchStoryAttributes(story)
      .then(result => {
        GA.registerPageView(this.props.pageType, {
          story: { ...story, collections: result.collections },
          collection: issueCollection,
          infiniteTagRequired: firedFromInfinite
        });
        DeepBI.registerPageView({ story: { ...story, collections: result.collections }, glance: false });
        WebEngage.registerPageView({ story, triggerArticleEvent: !firedFromInfinite });
      })
      .catch(console.error);
  };

  checkInfoStatus = stat => {
    const story = get(this.props, ["data", "story"]);
    this.setState({
      sequnce: 0
    });
    if (stat.status === true) {
      this.sendQlitics(story);
      this.setState({
        visibleStories: [...this.state.visibleStories, stat.id]
      });
    } else {
      let filteredArray = this.state.visibleStories.filter(item => item !== stat.id);
      this.setState({
        visibleStories: filteredArray
      });
    }
  };

  sendQlitics = (story = {}) => {
    const { registerStoryView } = require("@quintype/framework/client/analytics");
    registerStoryView(story.id);
  };

  handleActivePaywall = args => {
    this.setState({
      activePaywall: args
    });
  };

  handleSetStoryUrls = args => {
    this.setState({
      storyUrls: args
    });
  };

  handleStdActivePaywall = args => {
    this.setState({
      activeStdPaywall: args
    });
  };

  GetScrollValue = args => {
    this.UpdateStateScroll(args);
  };

  scrollFunction() {
    if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
      this.setState({ isVisible: true });
    } else {
      this.setState({ isVisible: false });
    }
  }

  render() {
    const metypeConfig = get(this.props, ["data", "publisherConfig", "metypeConfig"]);
    const paywallPlans = get(this.props, ["data", "publisherConfig", "paywallPlans"]);
    const razaorpayKey = get(this.props, ["data", "publisherConfig", "razarpayKey"]);
    const issueCollection = get(this.props, ["data", "issueCollection"]);
    const magazineView = get(issueCollection, ["magazineView"]);
    const magazineEntity = get(this.props, ["data", "magazineEntity"]);
    const { userType, trendingStories, rndNInt, rndPInt } = this.state;
    const story = get(this.props, ["data", "story"]);
    const episodes = get(this.props, ["data", "episodes"], []);
    const nextStoryUrl = get(trendingStories, [rndNInt, "story", "url"], null);
    const prevStoryUrl = get(trendingStories, [rndPInt, "story", "url"], null);

    return (
      <React.Fragment>
        {!checkMagazineUTM() && episodes ? (
          <div />
        ) : (
          <div className={styles["sticky-secondary-menu"]}>
            {magazineView && issueCollection && magazineEntity ? (
              <div className={styles["secondary-menu"]}>{generateSecondaryMenu(issueCollection, magazineEntity)}</div>
            ) : (
              <div />
            )}
          </div>
        )}

        <div className={styles["fixedUrl"]}>
          {nextStoryUrl && (
            <div className={styles["next-event"]}>
              <Link
                callback={() => {
                  if ("ga" in window) {
                    window.ga("send", "event", "Next Story", "Clicked", nextStoryUrl);
                  }
                }}
                href={`${nextStoryUrl}?pfrom=next-story-btn`}
                className={styles["next"]}
              >
                <Icon type="angle-right" className={styles["next-icon"]} />
              </Link>
            </div>
          )}
          {prevStoryUrl && (
            <div className={styles["prev-event"]}>
              <Link
                href={`${prevStoryUrl}?pfrom=prev-story-btn`}
                className={styles["prev"]}
                callback={() => {
                  if ("ga" in window) {
                    window.ga("send", "event", "Previous story", "Clicked", prevStoryUrl);
                  }
                }}
              >
                <Icon type="angle-left" className={styles["prev-icon"]} />
              </Link>
            </div>
          )}
        </div>

        <div
          className={`main-page ${styles["base"]} ${
            isPremium(story) || issueCollection ? styles["premium-article"] : styles["nonpremium-article"]
          } js-story-main-container`}
        >
          <div />

          <WithHostUrl>
            {({ currentHostUrl }) => (
              <WrapperStoryIntersectionObserver
                config={this.props.config}
                metypeConfig={metypeConfig}
                firePageView={() => this.firePageView(this.props.data.story)}
                READMORE_ENABLE={this.state.READMORE_ENABLE}
                checkInfoStatus={this.checkInfoStatus}
                versionStat={"v4"}
                activePaywall={this.state.activePaywall}
                actionhandleActivePaywall={this.handleActivePaywall}
                activeStdPaywall={this.state.activeStdPaywall}
                actionhandleStdActivePaywall={this.handleStdActivePaywall}
                GetScrollValue={this.GetScrollValue}
                userType={userType}
                latestStories={this.state.latestStories}
                trendingStories={this.state.trendingStories}
                paywallPlans={paywallPlans}
                razaorpayKey={razaorpayKey}
                story={story}
                issueCollection={issueCollection}
                magazineEntity={magazineEntity}
                index={0}
                episodes={episodes}
              />
            )}
          </WithHostUrl>
          <div />
        </div>
        <React.Fragment>
          <VikatanSticky placement="story" />
        </React.Fragment>
      </React.Fragment>
    );
  }
}

StoryFeedPage.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: TextStory.propTypes.story,
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  recentStory: PropTypes.object,
  paywallPlans: PropTypes.object,
  razaorpayKey: PropTypes.object,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string,
  actionhandleActivePaywall: PropTypes.func,
  activePaywall: PropTypes.bool,
  visualStories: PropTypes.shape(),
  actionhandleStdActivePaywall: PropTypes.func,
  GetScrollValue: PropTypes.func,
  activeStdPaywall: PropTypes.bool,
  latestStories: PropTypes.shape(),
  trendingStories: PropTypes.shape(),
  data: PropTypes.shape(),
  pageType: PropTypes.string
};
